import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CustomerImportComponent } from 'OpsCenter/merchants/importing/customers/customer-import.component';
import { CustomerImportService } from 'OpsCenter/merchants/importing/customers/customer-import.service';
import { ReservationsImportComponent } from 'OpsCenter/merchants/importing/reservations/reservations-import.component';
import { ReservationsImportService } from 'OpsCenter/merchants/importing/reservations/reservations-import.service';

@NgModule({
  imports: [
    HttpClientModule,
    CommonModule,
    FormsModule,
    RouterModule.forChild([
      { path: 'app/merchants-import-customers', component: CustomerImportComponent },
      { path: 'app/merchants-import-reservations', component: ReservationsImportComponent },
    ]),
  ],
  providers: [CustomerImportService, ReservationsImportService],
  declarations: [CustomerImportComponent, ReservationsImportComponent],
})
export default class ImportModule {}



// WEBPACK FOOTER //
// ./src/app/merchants/importing/import.module.ts